module.exports = __webpack_public_path__ + "img/USP_Icons-Extensive-Inventory.fb091fc.png";